import React from 'react';
import { useTranslations } from '../utils/translations';
import './LandscapeWarning.css';

const LandscapeWarning = ({ currentLanguage }) => {
  const { t } = useTranslations(currentLanguage);

  return (
    <div className="landscape-warning">
      <div className="rotate-icon">
        <svg width="64" height="64" viewBox="0 0 24 24" fill="currentColor">
          <path d="M16.48 2.52c3.27 1.55 5.61 4.72 5.97 8.48h1.5C23.44 4.84 18.29 0 12 0l-.66.03 3.81 3.81 1.33-1.32zm-6.25-.77c-.59-.59-1.54-.59-2.12 0L1.75 8.11c-.59.59-.59 1.54 0 2.12l12.02 12.02c.59.59 1.54.59 2.12 0l6.36-6.36c.59-.59.59-1.54 0-2.12L10.23 1.75zm4.6 19.44L2.81 9.17l6.36-6.36 12.02 12.02-6.36 6.36z"/>
        </svg>
      </div>
      <h2>{t('ui.landscape.title')}</h2>
      <p>{t('ui.landscape.message')}</p>
      <p className="instruction">{t('ui.landscape.instruction')}</p>
    </div>
  );
};

export default LandscapeWarning; 